import React, { useEffect } from "react";
import AboutIntroSection from "../components/AboutUs/AboutIntroSection"
import MissionVisionSection from "../components/AboutUs/MissionVisionSection";
import ContactMotivationBanner from "../components/AboutUs/AboutMotivationBanner"
import ValuesSection from "../components/AboutUs/ValuesSection";
import BlackDividerBottom from "../components/SectionDivider/BlackDividerBottom"
import BlackDividerTop from "../components/SectionDivider/BlackDividerTop"


function AboutUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <AboutIntroSection />
      <MissionVisionSection />
      <ContactMotivationBanner />
      <BlackDividerBottom />
      <ValuesSection />
      <BlackDividerTop />
    </div>
  );
}

export default AboutUs;